import { BrowserRouter } from "react-router-dom";
import AliGasht from "./components/AliGasht";

const App = () => {
  return (
    <BrowserRouter>
      <AliGasht />
    </BrowserRouter>
  );
};

export default App;
